module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Cap-1-1d01f48b4e2af0d6ab2e84a3f0ff55b2.svg";